// src/pages/ForumPage.js — V18 forum: list / detail / new-post modal.
import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import PostList from './forumcomponents/PostList';
import PostDetail from './forumcomponents/PostDetail';
import NewPostEditor from './forumcomponents/NewPostEditor';
import PageShell from '../components/PageShell';
import { PrimaryButton } from '../components/ui';
import { color } from '../theme/tokens';

const Toolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 20px;
    margin-bottom: 24px;
    border-bottom: 1px solid ${color.line};
    .tabs { display: flex; align-items: center; gap: 28px; font-size: 15px; letter-spacing: 0.12em; }
    .tabs span.on { color: ${color.text}; padding-bottom: 6px; border-bottom: 1px solid ${color.bloodHi}; }
    .hint { font-size: 13px; color: ${color.text3}; }
    @media (max-width: 720px) {
        flex-wrap: wrap;
        button { width: 100%; }
    }
`;

const ForumPage = () => {
    const { user } = useAuth();
    const [selectedPostId, setSelectedPostId] = useState(null);
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [refreshList, setRefreshList] = useState(false);

    const handleNewPostSuccess = () => {
        setIsEditorOpen(false);
        if (!selectedPostId) {
            setRefreshList((prev) => !prev);
        } else {
            setSelectedPostId(null);
            setTimeout(() => setRefreshList((prev) => !prev), 0);
        }
    };

    const handlePostDeleteSuccess = () => {
        setSelectedPostId(null);
        setRefreshList((prev) => !prev);
    };

    const isAdmin = user && ['site_owner', 'admin'].includes(user.role);
    const canPost = user && (user.level > 0 || isAdmin);
    const postHint = !user ? '登录后可发帖' : (!canPost ? '等级达到 Lv1 后可发帖' : '');

    return (
        <PageShell num="弐" title="論壇" en="FORUM" quote="永遠に街が続いていた。世界に果てはないんだって" sideLabel="帖子">
            {isEditorOpen && (
                <NewPostEditor closeModal={() => setIsEditorOpen(false)} onSuccess={handleNewPostSuccess} />
            )}

            {selectedPostId ? (
                <PostDetail
                    postId={selectedPostId}
                    onBack={() => setSelectedPostId(null)}
                    onDeleteSuccess={handlePostDeleteSuccess}
                />
            ) : (
                <>
                    <Toolbar>
                        <div className="tabs">
                            <span className="on">最新</span>
                            {postHint && <span className="hint">{postHint}</span>}
                        </div>
                        <PrimaryButton type="button" onClick={() => setIsEditorOpen(true)} disabled={!canPost} title={postHint || '发新帖'}>
                            执笔 · 发新帖
                        </PrimaryButton>
                    </Toolbar>
                    <PostList onPostSelect={setSelectedPostId} refreshTrigger={refreshList} />
                </>
            )}
        </PageShell>
    );
};

export default ForumPage;
